import {Actions, CommandActions, DocumentActions, RESET_AND_CLOSE_MODAL, SAVE_USERS, FETCH_INTERNAL_USERS, FETCH_EXTERNAL_USERS, REMOVE_INTERNAL_USERS, REMOVE_EXTERNAL_USERS, GET_STAKEHOLDER_IDS, SAVE_PERMISSIONS, REMOVE_NOTIFICATIONS_RELATED_TO_PERMISSIONS,
        FETCH_INTERNAL_ROLES, FETCH_EXTERNAL_ROLES, SAVE_INTERNAL_USERS, SAVE_EXTERNAL_USERS, FETCH_USERS, SAVE_NEW_EXTERNAL_USER, DOWNLOAD_USERS, CREATE_PROJECT_ROLES, CHECK_EXTERNAL_USER, SET_PERMISSIONS_FORM_AND_OPEN_MODAL, DELETE_PERMISSIONS, ADD_NOTIFICATIONS_RELATED_TO_PERMISSIONS,
        ADD_GLOBAL_PERMISSION} from "../../actions/administrationModal";
import {ApiConfigActions, ApiModels} from "@pwbapps/reduxcore";
import {Actions as ModalActions} from '@pwbapps/genericdialog';
import {CommandActions as LoaderCommandActions} from "../../actions/loader";
import {CommandActions as SharedCommandActions} from "../../actions/sharedData";
import {getInternalAppRoles, getExternalAppRoles, getInternalEditUsers, getExternalFilter, getInternalFilter, getExternalEditUsers, getExternalAppUsers} from "../../reducers/administrationModal";
import _ from 'lodash';
import { MessageBarType } from '@fluentui/react';
import { DocumentActions as NotificationDocumentActions} from "../../actions/notification";
import { AppUser, ExternalUserForm, Role, UserRoleApi } from "../../../models/administration";
import {addRoleToExternalUserUrl, addRoleToInternalUserUrl, getExternalUsersUrl, getInternalUsersUrl, getInternalRolesUrl, getExternalRolesUrl, newExternalUserUrl, dowloadUsersUrl, removeRoleToInternalUserUrl, removeRoleToExternalUserUrl, createInternalRoleUrl, createExternalRoleUrl, getSingleExternalUser, savePermissionsUrl, deletePermissionsUrl} from '../../../utils/administrationUrls';
import { getSelectedProjectId } from "../../reducers/project";
import { getLoader } from "../../selectors/loader";
import { getGenericModal } from "@pwbapps/genericdialog/dist/redux/selectors";
import { Modal } from "../../../models/modal";
import { validateEmail } from "../../../utils/functions";
import saveAs from "file-saver";
import { CommandActions as ProjectsCommandActions, DocumentActions as ProjectsDocumentActions } from "../../actions/project";
import { CommandActions as NotifySettingsCommandActions, EventActions as NotifySettingsEventActions } from "../../actions/notifySettings";
import { getAllStakeHolders, getPermissionIdsToRemove, getPermissions } from "../../reducers/sharedData";
import { getStakeholderIdsByCompaniesUrl } from "../../../utils/documentsUrls";
import { PermissionElement, PermissionElementPostData, Permissions } from "../../../models/permissions";
import { getEventTypes, getPermissionUserRules, getUiRules } from "../../reducers/notifySettings";
import { NotifyRule } from "../../../models/notifyRule";
import { ApplicationStakeHolder } from "../../../models/stakeHolder";
import { EventType } from "../../../models/eventType";
import { createRolesUrl } from "../../../utils/urls";

export const administrationModalMiddlewareHistory = (history: any) => {
    return administrationModalMiddleware(history);
}

export const administrationModalMiddleware = (history: any) => ({dispatch, getState}: {dispatch: any, getState: any}) => (next: any) => (action: Actions | ApiConfigActions.EventActions ) => {
    next(action);
    switch (action.type) {
        case FETCH_INTERNAL_ROLES:
            dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'GET', url: getInternalRolesUrl(), feature: FETCH_INTERNAL_ROLES}}));    
            break;

        case FETCH_EXTERNAL_ROLES:
            dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'GET', url: getExternalRolesUrl(), feature: FETCH_EXTERNAL_ROLES}}));    
            break;

        case FETCH_USERS:
            dispatch(CommandActions.fetchInternalUsers());
            dispatch(CommandActions.fetchExternalUsers());
            if(action.payload.openModal)
                dispatch(CommandActions.setOpenModal({value: true}));
            break;

        case FETCH_INTERNAL_USERS:
            let internalFilter = getInternalFilter(getState());        
            if(!getLoader('administration')(getState()).loadingInternal)
                next(LoaderCommandActions.setLoadingInternal({feature: 'administration', loading: true}));
            dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'GET', url: getInternalUsersUrl(getSelectedProjectId(getState()) as number, internalFilter), feature: FETCH_INTERNAL_USERS}}));       
            break;

        case FETCH_EXTERNAL_USERS:
            let externalFilter = getExternalFilter(getState());     
            if(!getLoader('administration')(getState()).loadingExternal)
                next(LoaderCommandActions.setLoadingExternal({feature: 'administration', loading: true}));
            dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'GET', url: getExternalUsersUrl(getSelectedProjectId(getState()) as number, externalFilter), feature: FETCH_EXTERNAL_USERS}}));          
            break;

        case RESET_AND_CLOSE_MODAL:
            next(CommandActions.setOpenModal({value: false}));
            next(DocumentActions.setUsersArray({arrayName: 'internalEditedUsers', users: []}));
            next(DocumentActions.setUsersArray({arrayName: 'internalAppUsers', users: []})); 
            next(DocumentActions.setUsersArray({arrayName: 'externalEditedUsers', users: []}));
            next(DocumentActions.setUsersArray({arrayName: 'externalAppUsers', users: []})); 
            next(LoaderCommandActions.setLoading({feature: 'administration', loading: false}));
            next(CommandActions.setInternalFilter({value: undefined}));
            next(CommandActions.setExternalFilter({value: undefined}));
            next(NotificationDocumentActions.setNotificationStatus({name: 'administration', show: false, type: MessageBarType.info, message: ''})); 
            break;

        case SAVE_USERS: {
            const internalEditedUsers = getInternalEditUsers(getState());
            let externalEditedUsers = getExternalEditUsers(getState());
            if(internalEditedUsers.length > 0 || externalEditedUsers.length > 0){
                next(LoaderCommandActions.setLoading({feature: 'administration', loading: true}));
                const internalEditUsersToAdd = _.filter(internalEditedUsers, iu => iu.role && iu.role.name !== 'NONE') as AppUser[];
                const internalEditUsersToRemove = _.filter(internalEditedUsers, iu => iu.role && iu.role.name === 'NONE') as AppUser[];
                if(internalEditUsersToAdd.length > 0){
                    next(LoaderCommandActions.setLoadingInternal({feature: 'administration', loading: true}));
                    dispatch(CommandActions.saveInternalUsers({editedUsers: internalEditUsersToAdd}));
                    dispatch(NotifySettingsEventActions.saveMultipleRules({users: internalEditUsersToAdd as AppUser[], isExternal: false}));
                    dispatch(NotifySettingsEventActions.deleteMultipleRules({users: internalEditUsersToAdd, all: false, isExternal: false}));
                }
                if(internalEditUsersToRemove.length > 0){
                    next(LoaderCommandActions.setLoadingInternalRemove({feature: 'administration', loading: true}));
                    dispatch(CommandActions.removeInternalUsers({editedUsers: internalEditUsersToRemove}));
                    dispatch(NotifySettingsEventActions.deleteMultipleRules({users: internalEditUsersToRemove, all: true, isExternal: false}));
                }
                let externalEditUsersToAdd = _.filter(externalEditedUsers, eu => eu.role && eu.role.name !== 'NONE') as AppUser[];
                const externalEditUsersToRemove = _.filter(externalEditedUsers, eu => eu.role && eu.role.name === 'NONE') as AppUser[];
                if(externalEditUsersToAdd.length > 0){
                    next(LoaderCommandActions.setLoadingExternal({feature: 'administration', loading: true}));

                    externalEditUsersToAdd = _.map(externalEditUsersToAdd, e => {return {...e, stakeHolderId: undefined}});
                    // controllo che ci siano gli stakeholder ids di tutti gli utenti
                    if(!_.some(externalEditUsersToAdd, eu => !eu.stakeHolderId)){
                        dispatch(CommandActions.saveExternalUsers({editedUsers: externalEditUsersToAdd, dontReload: true}));                  
                        dispatch(NotifySettingsEventActions.saveMultipleRules({users: externalEditUsersToAdd as AppUser[], isExternal: true}));
                        dispatch(NotifySettingsEventActions.deleteMultipleRules({users: externalEditUsersToAdd, all: false, isExternal: true}));       
                        // salva permessions per gli utenti esterni che non hanno ancora un ruolo per questo progetto
                        let selectedProjectId: number = getSelectedProjectId(getState());
                        _.forEach(externalEditUsersToAdd, (u: AppUser) => {
                            if(u.isNew){
                                let allZero: PermissionElementPostData = {id: 0, email: u.email as string, projectId: selectedProjectId, pbs: 'ALL', discipline: 'ALL', canWrite: true, stakeHolderId: (u.stakeHolderId) ? u.stakeHolderId : undefined}
                                dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'POST', body: [allZero], url: savePermissionsUrl(), feature: SAVE_PERMISSIONS, returnObject: {permissionForm: undefined, permissionIdsToRemove: []}}}));  
                            }
                        });
                    }
                    else{
                        dispatch(CommandActions.getStakeHolderIds({companies: _.uniq(_.map(externalEditUsersToAdd, u => u.company as string)), updateEditUsers: true}));
                        var refreshIntervalId = setInterval(() => {
                            externalEditedUsers = getExternalEditUsers(getState());
                            externalEditUsersToAdd = _.filter(externalEditedUsers, eu => eu.role && eu.role.name !== 'NONE') as AppUser[];
                            if(!_.some(externalEditUsersToAdd, eu => !eu.stakeHolderId)){
                                dispatch(CommandActions.saveExternalUsers({editedUsers: externalEditUsersToAdd, dontReload: true}));                  
                                dispatch(NotifySettingsEventActions.saveMultipleRules({users: externalEditUsersToAdd as AppUser[], isExternal: true}));
                                dispatch(NotifySettingsEventActions.deleteMultipleRules({users: externalEditUsersToAdd, all: false, isExternal: true}));  
                                // salva permessions per gli utenti esterni che non hanno ancora un ruolo per questo progetto
                                let selectedProjectId: number = getSelectedProjectId(getState());
                                _.forEach(externalEditUsersToAdd, (u: AppUser) => {
                                    if(u.isNew){
                                        let allZero: PermissionElementPostData = {id: 0, email: u.email as string, projectId: selectedProjectId, pbs: 'ALL', discipline: 'ALL', canWrite: true, stakeHolderId: (u.stakeHolderId) ? u.stakeHolderId : undefined}
                                        dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'POST', body: [allZero], url: savePermissionsUrl(), feature: SAVE_PERMISSIONS, returnObject: {permissionForm: undefined, permissionIdsToRemove: []}}}));  
                                    }
                                });                   
                                clearInterval(refreshIntervalId);
                            }                      
                        }, 500);    
                    }
                    
                }
                if(externalEditUsersToRemove.length > 0){
                    next(LoaderCommandActions.setLoadingExternalRemove({feature: 'administration', loading: true}));
                    dispatch(CommandActions.removeExternalUsers({editedUsers: externalEditUsersToRemove}));
                    dispatch(NotifySettingsEventActions.deleteMultipleRules({users: externalEditUsersToRemove, all: true, isExternal: true}));
                }
            }
            break;
        }

        case SAVE_INTERNAL_USERS: {
            const internalEditedUsers = action.payload.editedUsers;
            if(internalEditedUsers.length > 0){
                const ieu = internalEditedUsers[0];
                const userRole: UserRoleApi = new UserRoleApi(ieu);       
                dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'PUT', url: addRoleToInternalUserUrl(userRole), feature: SAVE_INTERNAL_USERS, returnObject: {internalEditedUsers: _.filter(internalEditedUsers, u => u.id !== ieu.id)}}}));
            }          
            break;
        }

        case REMOVE_INTERNAL_USERS: {
            const internalEditedUsers = action.payload.editedUsers;
            if(internalEditedUsers.length > 0){
                const ieu = internalEditedUsers[0];
                const userRoleId = (ieu.role) ? ieu.role.userRoleId : undefined;  
                if(userRoleId)     
                    dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'DELETE', url: removeRoleToInternalUserUrl(userRoleId), feature: REMOVE_INTERNAL_USERS, returnObject: {internalEditedUsers: _.filter(internalEditedUsers, u => u.id !== ieu.id)}}}));
            }          
            break;
        }

        case SAVE_EXTERNAL_USERS: {
            const externalEditedUsers = action.payload.editedUsers;
            const dontReload = action.payload.dontReload;
            if(externalEditedUsers.length > 0){
                const ieu = externalEditedUsers[0];
                const userRole: UserRoleApi = new UserRoleApi(ieu);     
                dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'PUT', url: addRoleToExternalUserUrl(userRole), feature: SAVE_EXTERNAL_USERS, returnObject: {externalEditedUsers: _.filter(externalEditedUsers, u => u.id !== ieu.id), dontReload}}}));
            }          
            break;
        }

        case REMOVE_EXTERNAL_USERS: {
            const externalEditedUsers = action.payload.editedUsers;
            if(externalEditedUsers.length > 0){
                const ieu = externalEditedUsers[0];
                const userRoleId = (ieu.role) ? ieu.role.userRoleId : undefined;   
                if(userRoleId) 
                    dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'DELETE', url: removeRoleToExternalUserUrl(userRoleId), feature: REMOVE_EXTERNAL_USERS, returnObject: {externalEditedUsers: _.filter(externalEditedUsers, u => u.id !== ieu.id)}}}));
            }          
            break;
        }
       
        case SAVE_NEW_EXTERNAL_USER: {
            const newUserForm = (getGenericModal('newExternalUser')(getState())) ? (getGenericModal('newExternalUser')(getState()) as Modal).contextItem as ExternalUserForm : undefined;
            if(newUserForm){
                if(newUserForm.email && newUserForm.company && newUserForm.country && newUserForm.role){
                    next(LoaderCommandActions.setLoadingExternal({feature: 'administration', loading: true}));
                    dispatch(CommandActions.checkExternalUser({newUserForm}));
                } 
                else
                   validateExternalUser(newUserForm, next, getState);            
            }          
            break;
        }

        case CHECK_EXTERNAL_USER: {
            const newUserForm = action.payload.newUserForm;
            if(newUserForm && newUserForm.email){    
                let vaildEmail = (newUserForm.email) ? (validateEmail(newUserForm.email) ? true : false) : false;
                if(vaildEmail)
                    dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'GET', url: getSingleExternalUser(getSelectedProjectId(getState()) as number, newUserForm.email as string), feature: CHECK_EXTERNAL_USER, returnObject: {newUserForm}}}));    
                else
                    next(ModalActions.DocumentActions.setContextItemProperty({id: 'newExternalUser', name: 'errors', value: {...((getGenericModal('newExternalUser')(getState()) as Modal).contextItem as ExternalUserForm).errors, email: (!newUserForm.email) ? 'This field is mandatory' : ((vaildEmail) ? undefined : 'Invalid email format')}}));
            }          
            break;
        }

        case DOWNLOAD_USERS:
            next(LoaderCommandActions.setLoading({feature: 'administration', loading: true}));
            dispatch(ApiConfigActions.CommandActions.apiTokenRequest({
                request: { 
                    method: 'POST',  
                    headers: [{name: 'Accept', value: 'application/octet-stream'}],
                    responseType: 'arraybuffer',
                    body: {
                        projectIds: [getSelectedProjectId(getState()) as number],
                        fileName: (getSelectedProjectId(getState()) as number) + '_Users' 
                    },
                    url: dowloadUsersUrl(), 
                    feature: DOWNLOAD_USERS,
                    returnObject: {fileName: (getSelectedProjectId(getState()) as number) + '_Users' }
                }
            }));    
            break;

        // case CREATE_PROJECT_ROLES:
        //     const projectId = action.payload.projectId;
        //     let requests: ApiModels.Request[] = [
        //         { method: 'POST', url: createInternalRoleUrl(projectId + '_ADMINISTRATOR'), feature: 'CREATE INTERNAL ADMINISTRATOR'},
        //         { method: 'POST', url: createInternalRoleUrl(projectId + '_EEOHANDLER'), feature: 'CREATE INTERNAL EEOHANDLER'},
        //         { method: 'POST', url: createInternalRoleUrl(projectId + '_PUBLISHER'), feature: 'CREATE INTERNAL PUBLISHER'},
        //         { method: 'POST', url: createInternalRoleUrl(projectId + '_READER'), feature: 'CREATE INTERNAL READER'},
        //         { method: 'POST', url: createExternalRoleUrl(projectId + '_SUPPLIER'), feature: 'CREATE EXTERNAL SUPPLIER'},
        //         { method: 'POST', url: createExternalRoleUrl(projectId + '_CHECKER'), feature: 'CREATE EXTERNAL CHECKER'},
        //         { method: 'POST', url: createExternalRoleUrl(projectId + '_APPROVER'), feature: 'CREATE EXTERNAL APPROVER'},
        //         { method: 'POST', url: createExternalRoleUrl(projectId + '_PARTNER'), feature: 'CREATE EXTERNAL PARTNER'},
        //         { method: 'POST', url: createExternalRoleUrl(projectId + '_PARTNER-COMMENTATOR'), feature: 'CREATE EXTERNAL PARTNER COMMENTATOR'},
        //         { method: 'POST', url: createExternalRoleUrl(projectId + '_READER'), feature: 'CREATE EXTERNAL READER'}
        //     ];
        //     dispatch(ApiConfigActions.CommandActions.apiMultipleTokenRequest({requests, externalFeature: CREATE_PROJECT_ROLES}));
        //     break;

        case CREATE_PROJECT_ROLES:
            let projectId = action.payload.projectId as any;
            projectId = _.replace(projectId, /\s/g, '');

            const request: ApiModels.Request = {
                method: 'POST',
                url: createRolesUrl(),
                feature: 'CREATE PROJECT ROLES',
                headers: [{ name: 'Content-Type', value: 'application/json' }],
                body: {
                    projectId,
                    roles: [
                        { description: `${projectId}_ADMINISTRATOR`, displayName: `${projectId}_ADMINISTRATOR`, value: `${projectId}_ADMINISTRATOR`, external: false },
                        { description: `${projectId}_EEOHANDLER`, displayName: `${projectId}_EEOHANDLER`, value: `${projectId}_EEOHANDLER`, external: false },
                        { description: `${projectId}_PUBLISHER`, displayName: `${projectId}_PUBLISHER`, value: `${projectId}_PUBLISHER`, external: false },
                        { description: `${projectId}_READER`, displayName: `${projectId}_READER`, value: `${projectId}_READER`, external: false },

                        { description: `${projectId}_SUPPLIER`, displayName: `${projectId}_SUPPLIER`, value: `${projectId}_SUPPLIER`, external: true },
                        { description: `${projectId}_CHECKER`, displayName: `${projectId}_CHECKER`, value: `${projectId}_CHECKER`, external: true },
                        { description: `${projectId}_APPROVER`, displayName: `${projectId}_APPROVER`, value: `${projectId}_APPROVER`, external: true },
                        { description: `${projectId}_PARTNER`, displayName: `${projectId}_PARTNER`, value: `${projectId}_PARTNER`, external: true },
                        { description: `${projectId}_PARTNER-COMMENTATOR`, displayName: `${projectId}_PARTNER-COMMENTATOR`, value: `${projectId}_PARTNER-COMMENTATOR`, external: true },
                        { description: `${projectId}_READER`, displayName: `${projectId}_READER`, value: `${projectId}_READER`, external: true }
                    ]
                }
            };

            dispatch(ApiConfigActions.CommandActions.apiTokenRequest({ request }));
        break;

        case GET_STAKEHOLDER_IDS:
            const companies = action.payload.companies;
            const updateEditUsers = action.payload.updateEditUsers;
            if(companies.length > 0)
                dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'GET', url: getStakeholderIdsByCompaniesUrl(companies), feature: GET_STAKEHOLDER_IDS, returnObject: {updateEditUsers}}}));    
            else{

            }
            break;

        case SET_PERMISSIONS_FORM_AND_OPEN_MODAL: {
            let newPermissionsForm: Permissions = {email: action.payload.email, permissions: action.payload.permissionElements, stakeHolderId: action.payload.stakeHolderId}
            if(newPermissionsForm && newPermissionsForm.email)
                dispatch(ModalActions.CommandActions.openModal({id: 'permissions', contextItem: newPermissionsForm}));       
                dispatch(NotifySettingsCommandActions.fetchUsersRules({users: [{email: action.payload.email, isNew: true}], isExternal: true, forPermissions: true}));          
            break;
        }

        case ADD_GLOBAL_PERMISSION: {
            const email = action.payload.email;
            let rowPost: PermissionElementPostData = {id: 0, email, pbs: 'ALL', discipline: 'ALL', canWrite: true, projectId: getSelectedProjectId(getState()) as number };   
            dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'POST', body: [rowPost], url: savePermissionsUrl(), feature: ADD_GLOBAL_PERMISSION}}));    
            break;
        }

        case SAVE_PERMISSIONS: {
            let permissionForm: Permissions | undefined = ((getGenericModal('permissions')(getState())) ? (getGenericModal('permissions')(getState()) as any).contextItem as Permissions : undefined);     
            const permissionIdsToRemove: number[] = getPermissionIdsToRemove(getState());
            if(permissionIdsToRemove.length > 0 || (permissionForm && !_.some(permissionForm.permissions, (p: PermissionElement) => !p.pbs && !p.disciplineCode)))     
                next(LoaderCommandActions.setLoadingExternal({feature: 'administration', loading: true}));
            if(permissionForm && !_.some(permissionForm.permissions, (p: PermissionElement) => !p.pbs && !p.disciplineCode) ){
                let rowsPost: PermissionElementPostData[] = _.map(permissionForm.permissions, p => {return new PermissionElementPostData(p, (permissionForm as Permissions).email as string, getSelectedProjectId(getState()) as number, (permissionForm as Permissions).stakeHolderId as number)})
                dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'POST', body: rowsPost, url: savePermissionsUrl(), feature: SAVE_PERMISSIONS, returnObject: {permissionIdsToRemove, permissionForm}}}));    
            }   
            else if(permissionIdsToRemove.length > 0){
                dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'DELETE', body: {ids: permissionIdsToRemove}, url: deletePermissionsUrl(), feature: DELETE_PERMISSIONS}}));
            }                    
            break;
        }

        case ApiConfigActions.API_SUCCESS:
            apiSuccessMiddleware(dispatch, getState, next, action);         
            break;
    
        case ApiConfigActions.API_ERROR:
            apiErrorMiddleware(dispatch, getState, next, action);         
            break;
       
        default:
            break;
    }
};


const apiSuccessMiddleware = (dispatch: any, getState: any, next: any, action: ApiConfigActions.ApiSuccessAction) => {
    switch(action.meta.feature){
        case FETCH_INTERNAL_ROLES: {
            let roles = (action.payload) ? action.payload : undefined;
            let rolesMapped = _.map(roles, p => {return new Role(p)});
            next(CommandActions.setInternalRoles({value: [{id: 'NONE', name: 'NONE', azureName: 'NONE'}, ...rolesMapped]}));
            break;
        }

        case FETCH_EXTERNAL_ROLES: {
            let roles = (action.payload) ? action.payload : undefined;
            let rolesMapped = _.map(roles, p => {return new Role(p)});
            next(CommandActions.setExternalRoles({value: [{id: 'NONE', name: 'NONE', azureName: 'NONE'}, ...rolesMapped]}));
            break;
        }

        case FETCH_INTERNAL_USERS: {
            let internalUsers = (action.payload) ? action.payload : undefined;
            let internalUsersMapped = _.map(internalUsers, p => {return new AppUser(p, getInternalAppRoles(getState()))});
            internalUsersMapped = _.filter(internalUsersMapped, iu => iu.email) as AppUser[]; // filtro utenti senza email
            let internalEditUsers = getInternalEditUsers(getState());
            if(internalEditUsers.length > 0){
                internalUsersMapped = _.map(internalUsersMapped, (u) => { 
                    let userEdited = _.find(internalEditUsers, (eu) => { return u.email === eu.email});
                    return (userEdited) ? userEdited : u;
                });
            }
            if(internalUsersMapped.length > 0){
                dispatch(NotifySettingsCommandActions.fetchUsersRules({users: internalUsersMapped, isExternal: false}));    
            }
            else {
                next(LoaderCommandActions.setLoadingInternal({feature: 'administration', loading: false}));
            }
            break;
        }

        case FETCH_EXTERNAL_USERS: {
            let externalUsers = (action.payload) ? action.payload : undefined;
            let externalUsersMapped = _.map(externalUsers, p => {return new AppUser(p, getExternalAppRoles(getState()), getPermissions(getState()))});
            externalUsersMapped = _.filter(externalUsersMapped, (eu: AppUser) => eu.email) as AppUser[]; // filtro utenti senza email
            let externalEditUsers = getExternalEditUsers(getState());
            if(externalEditUsers.length > 0){
                externalUsersMapped = _.map(externalUsersMapped, (u) => { 
                    let userEdited = _.find(externalEditUsers, (eu) => { return u.email === eu.email});
                    return (userEdited) ? userEdited : u;
                });
            }
            if(externalUsersMapped.length > 0){
                dispatch(NotifySettingsCommandActions.fetchUsersRules({users: externalUsersMapped, isExternal: true}));
                if(_.some(externalUsersMapped, u => u.company))
                    dispatch(CommandActions.getStakeHolderIds({companies: _.uniq(_.map(externalUsersMapped, u => u.company as string))}));
                else{
                    next(LoaderCommandActions.setLoadingExternal({feature: 'administration', loading: false}));           
                }
            }
            else{
                next(LoaderCommandActions.setLoadingExternal({feature: 'administration', loading: false}));           
            }
            break;
        }

        case SAVE_INTERNAL_USERS: {
            let internalEditedUsers: AppUser[] = action.meta.returnObject.internalEditedUsers;
            if(internalEditedUsers.length > 0){
                dispatch(CommandActions.saveInternalUsers({editedUsers: internalEditedUsers}));
            }
            else {
                next(LoaderCommandActions.setLoadingInternal({feature: 'administration', loading: false}));
                if(!getLoader('administration')(getState()).loadingInternalRemove && !getLoader('administration')(getState()).loadingInternalNotification && !getLoader('administration')(getState()).loadingExternalNotificationRemove){
                    next(DocumentActions.setUsersArray({arrayName: 'internalEditedUsers', users: []}));
                    dispatch(CommandActions.fetchInternalUsers());
                    const externalEditUsers = getExternalEditUsers(getState());
                    if(externalEditUsers.length === 0){
                        next(NotificationDocumentActions.setNotificationStatus({name: 'administration', show: true, type: MessageBarType.success, message: 'User permissions saved successfully'}));  
                    }
                }
            }
            break;
        }

        case REMOVE_INTERNAL_USERS: {
            let internalEditedUsers: AppUser[] = action.meta.returnObject.internalEditedUsers;
            if(internalEditedUsers.length > 0){
                dispatch(CommandActions.removeInternalUsers({editedUsers: internalEditedUsers}));
            }
            else {
                next(LoaderCommandActions.setLoadingInternalRemove({feature: 'administration', loading: false}));
                if(!getLoader('administration')(getState()).loadingInternal && !getLoader('administration')(getState()).loadingInternalNotification && !getLoader('administration')(getState()).loadingExternalNotificationRemove){
                    next(DocumentActions.setUsersArray({arrayName: 'internalEditedUsers', users: []}));
                    dispatch(CommandActions.fetchInternalUsers());
                    const externalEditUsers = getExternalEditUsers(getState());
                    if(externalEditUsers.length === 0){
                        next(NotificationDocumentActions.setNotificationStatus({name: 'administration', show: true, type: MessageBarType.success, message: 'User permissions saved successfully'}));  
                    }
                }
            }
            break;
        }

        case SAVE_EXTERNAL_USERS: {
            let externalEditedUsers: AppUser[] = action.meta.returnObject.externalEditedUsers;
            const dontReload = action.meta.returnObject.dontReload;
            if(externalEditedUsers.length > 0){
                dispatch(CommandActions.saveExternalUsers({editedUsers: externalEditedUsers}));
            }
            else {         
                let newUser = action.meta.returnObject.new;
                next(LoaderCommandActions.setLoadingExternal({feature: 'administration', loading: false}));  
                if(newUser){
                    if(!dontReload)
                        dispatch(CommandActions.fetchExternalUsers());
                    dispatch(ModalActions.CommandActions.closeModal({id: 'newExternalUser'}));
                    next(NotificationDocumentActions.setNotificationStatus({name: 'administration', show: true, type: MessageBarType.success, message: 'User created successfully'}));  
                }
                else if(!getLoader('administration')(getState()).loadingExternalRemove && !getLoader('administration')(getState()).loadingExternalNotification && !getLoader('administration')(getState()).loadingInternalNotificationRemove){  
                    next(DocumentActions.setUsersArray({arrayName: 'externalEditedUsers', users: []}));
                    if(!dontReload)
                        dispatch(CommandActions.fetchExternalUsers());
                    const internalEditUsers = getInternalEditUsers(getState());
                    if(internalEditUsers.length === 0){
                        next(NotificationDocumentActions.setNotificationStatus({name: 'administration', show: true, type: MessageBarType.success, message: 'User permissions saved successfully'}));  
                    }
                }
            }
            break;
        }

        case REMOVE_EXTERNAL_USERS: {
            let externalEditedUsers: AppUser[] = action.meta.returnObject.externalEditedUsers;
            if(externalEditedUsers.length > 0){
                dispatch(CommandActions.removeExternalUsers({editedUsers: externalEditedUsers}));
            }
            else {   
                next(LoaderCommandActions.setLoadingExternalRemove({feature: 'administration', loading: false}));   
                if(!getLoader('administration')(getState()).loadingExternal && !getLoader('administration')(getState()).loadingExternalNotification && !getLoader('administration')(getState()).loadingInternalNotificationRemove){
                    next(DocumentActions.setUsersArray({arrayName: 'externalEditedUsers', users: []}));
                    dispatch(CommandActions.fetchExternalUsers());
                    const externalEditUsers = getExternalEditUsers(getState());
                    if(externalEditUsers.length === 0){
                        next(NotificationDocumentActions.setNotificationStatus({name: 'administration', show: true, type: MessageBarType.success, message: 'User permissions saved successfully'}));  
                    }
                }      
            }
            break;
        }

        case SAVE_NEW_EXTERNAL_USER: {
            let email = action.meta.returnObject.email as string;
            let role = action.meta.returnObject.role as Role;
            let userId = (action.payload) ? action.payload.idUser : undefined;
            let externalUserMapped: AppUser =  {id: userId, email, role, isNew: true };
            const userRole: UserRoleApi = new UserRoleApi(externalUserMapped);     
            dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'PUT', url: addRoleToExternalUserUrl(userRole), feature: SAVE_EXTERNAL_USERS, returnObject: {externalEditedUsers: [], new: true}}}));         
            break;
        }

        case CHECK_EXTERNAL_USER: {
            let newUserForm = action.meta.returnObject.newUserForm as ExternalUserForm;
            let externalUser = (action.payload && action.payload.length > 0) ? action.payload[0] : undefined;
            let externalUserMapped = (externalUser) ? new AppUser(externalUser, getExternalAppRoles(getState()), getPermissions(getState())) : undefined;
            if(!externalUserMapped){
                next(ModalActions.DocumentActions.setContextItemProperty({id: 'newExternalUser', name: 'errors', value: { email: undefined, country: undefined}}));
                dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'POST', url: newExternalUserUrl(newUserForm), feature: SAVE_NEW_EXTERNAL_USER, returnObject: {email: newUserForm.email, role: newUserForm.role}}}));
                const selectedProjectId = getSelectedProjectId(getState());
                if(selectedProjectId){ 
                    // const tkseNot = _.find(getEventTypes(getState()), (e: EventType) => e.name === "TkseReport") as EventType;
                    // dispatch(NotifySettingsEventActions.saveRule({rule: {eventTypeId: tkseNot.eventTypeId, mail: true, msChat: false, msNotificationTeam: false, userId: newUserForm.email, userName: newUserForm.email} as NotifyRule, forPermissions: true}));
                    let allStakeholders = getAllStakeHolders(getState());
                    let userStakeholder = _.find(allStakeholders, (as: ApplicationStakeHolder) => as.companyName === newUserForm.company);
                    let allZero: PermissionElementPostData = {id: 0, email: newUserForm.email as string, projectId: selectedProjectId, pbs: 'ALL', discipline: 'ALL', canWrite: true, stakeHolderId: (userStakeholder) ? userStakeholder.stakeHolderId : undefined}
                    dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'POST', body: [allZero], url: savePermissionsUrl(), feature: SAVE_PERMISSIONS, returnObject: {permissionForm: undefined, permissionIdsToRemove: []}}}));    
                }                
            }
            else{
                next(LoaderCommandActions.setLoadingExternal({feature: 'administration', loading: false}));
                validateExternalUser(newUserForm, next, getState);   
                next(ModalActions.DocumentActions.setContextItemProperty({id: 'newExternalUser', name: 'errors', value: {...((getGenericModal('newExternalUser')(getState()) as Modal).contextItem as ExternalUserForm).errors, email: 'This email is already used' }}));
            }
            
            break;
        }

        case DOWNLOAD_USERS: {
            let xlsx = action.payload;
            let fileName = action.meta.returnObject.fileName as string;
            if(xlsx) 
                saveAs(new Blob([xlsx]),`${fileName}.xlsx`);
            dispatch(LoaderCommandActions.setLoading({ feature: 'administration', loading: false}));
            next(NotificationDocumentActions.setNotificationStatus({name: 'administration', show: true, type: MessageBarType.success, message: 'Download completed'}));  
            setTimeout(() => { next(NotificationDocumentActions.setNotificationStatus({name: 'administration', show: false, type: MessageBarType.info, message: ''})); }, 5000);
            break;
        }

        case 'CREATE EXTERNAL READER':
            dispatch(CommandActions.fetchInternalRoles());
            dispatch(CommandActions.fetchExternalRoles());
            dispatch(ProjectsCommandActions.fetchProjects({isConfigurationPage: true}));
            dispatch(ProjectsCommandActions.fetchProjects({}));
            next(ProjectsDocumentActions.setModalOpened({value: false}));
            next(NotificationDocumentActions.setNotificationStatus({name: 'project', show: true, type: MessageBarType.success, message: 'Project saved successfully'})); 
            setTimeout(() => { next(NotificationDocumentActions.setNotificationStatus({name: 'project', show: false, type: MessageBarType.info, message: ''})); }, 5000);  
            break;

        case GET_STAKEHOLDER_IDS: {
            let stakeHoldersPayload = (action.payload && action.payload.value) ? action.payload.value : undefined;
            const updateEditUsers: boolean | undefined = action.meta.returnObject.updateEditUsers;
            let us = getExternalAppUsers(getState());
            let externalUsersUpdated = _.map(getExternalAppUsers(getState()), u => {return {...u, stakeHolderId: _.find(stakeHoldersPayload, s => s.companyName && u.company && s.companyName === u.company) ? ((_.find(stakeHoldersPayload, s => s.companyName && u.company && s.companyName === u.company) as any).stakeHolderId as number) : undefined} }) as AppUser[];
            next(CommandActions.setExternalUsers({value: _.orderBy(externalUsersUpdated, iu => iu.name)}));
            if(updateEditUsers){
                let externalEditUsersUpdated = _.map(getExternalEditUsers(getState()), u => {return {...u, stakeHolderId: _.find(stakeHoldersPayload, s => s.companyName && u.company && s.companyName === u.company) ? ((_.find(stakeHoldersPayload, s => s.companyName && u.company && s.companyName === u.company) as any).stakeHolderId as number) : undefined} }) as AppUser[];
                next(CommandActions.setExternalEditUsers({value: _.orderBy(externalEditUsersUpdated, iu => iu.name)}));
            }
            next(LoaderCommandActions.setLoadingExternal({feature: 'administration', loading: false}));    
            break;
        }

        case ADD_GLOBAL_PERMISSION: {
                         
            break;
        }

        case SAVE_PERMISSIONS: {
            const permissionForm: Permissions | undefined = action.meta.returnObject.permissionForm;
            const permissionIdsToRemove: number[] = action.meta.returnObject.permissionIdsToRemove;      
            if(permissionIdsToRemove.length === 0){
                dispatch(SharedCommandActions.fetchPermissions({loadExternalUsers: true})); 
                dispatch(ModalActions.CommandActions.closeModal({id: 'permissions'}));                 
            }
            else{
                dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'DELETE', body: {ids: permissionIdsToRemove}, url: deletePermissionsUrl(), feature: DELETE_PERMISSIONS, returnObject: {permissionForm}}}));   
            }
            break;
        }

        case DELETE_PERMISSIONS: {
            dispatch(SharedCommandActions.setPermissionIdsToRemove({value: []})); 
            dispatch(SharedCommandActions.fetchPermissions({loadExternalUsers: true})); 
            dispatch(ModalActions.CommandActions.closeModal({id: 'permissions'}));                 
            break;
        }
            
        default:
            break;
    }
}

const apiErrorMiddleware = (dispatch: any, history: any, next: any, action: ApiConfigActions.ApiErrorAction) => {
    switch(action.meta.feature){
        case FETCH_INTERNAL_ROLES: 
            next(NotificationDocumentActions.setNotificationStatus({name: 'administration', show: true, type: MessageBarType.error, message: 'Cannot fetch internal app roles. Please refresh the page'}));  
            break;

        case FETCH_EXTERNAL_ROLES: 
            next(NotificationDocumentActions.setNotificationStatus({name: 'administration', show: true, type: MessageBarType.error, message: 'Cannot fetch external app roles. Please refresh the page'}));  
            break;

        case FETCH_INTERNAL_USERS: 
            next(LoaderCommandActions.setLoadingInternal({feature: 'administration', loading: false}));
            next(NotificationDocumentActions.setNotificationStatus({name: 'administration', show: true, type: MessageBarType.error, message: 'Cannot fetch internal users. Please retry'}));  
            break;

        case FETCH_EXTERNAL_USERS: 
            next(LoaderCommandActions.setLoadingExternal({feature: 'administration', loading: false}));
            next(NotificationDocumentActions.setNotificationStatus({name: 'administration', show: true, type: MessageBarType.error, message: 'Cannot fetch external users. Please retry'}));  
            break;

        case SAVE_USERS:
            next(LoaderCommandActions.setLoading({feature: 'administration', loading: false}));
            next(NotificationDocumentActions.setNotificationStatus({name: 'administration', show: true, type: MessageBarType.error, message: 'Cannot save users. Please retry'}));  
            break;

        case SAVE_INTERNAL_USERS:
            next(LoaderCommandActions.setLoading({feature: 'administration', loading: false}));
            next(LoaderCommandActions.setLoadingInternal({feature: 'administration', loading: false}));
            next(NotificationDocumentActions.setNotificationStatus({name: 'administration', show: true, type: MessageBarType.error, message: 'Cannot save internal users. Please retry'}));  
            break;

        case SAVE_EXTERNAL_USERS:
            next(LoaderCommandActions.setLoading({feature: 'administration', loading: false}));
            next(LoaderCommandActions.setLoadingExternal({feature: 'administration', loading: false}));
            next(NotificationDocumentActions.setNotificationStatus({name: 'administration', show: true, type: MessageBarType.error, message: 'Cannot save external users. Please retry'}));  
            break;

        case SAVE_NEW_EXTERNAL_USER:
            next(LoaderCommandActions.setLoadingExternal({feature: 'administration', loading: false}));
            next(NotificationDocumentActions.setNotificationStatus({name: 'administration', show: true, type: MessageBarType.error, message: 'Cannot create new external user. Please retry'}));  
            break;

        case DOWNLOAD_USERS: {
            next(LoaderCommandActions.setLoading({feature: 'administration', loading: false}));
            next(NotificationDocumentActions.setNotificationStatus({name: 'administration', show: true, type: MessageBarType.error, message: 'Cannot download user report. Please retry'}));  
            break;
        }

        case SAVE_PERMISSIONS: {
            next(LoaderCommandActions.setLoadingExternal({feature: 'administration', loading: false}));
            next(NotificationDocumentActions.setNotificationStatus({name: 'administration', show: true, type: MessageBarType.error, message: 'Cannot save permissions. Please retry'}));  
            break;
        }
    

        default:
            break;
    }
}

const validateExternalUser = (newUserForm: ExternalUserForm, next: any, getState: any) => {
    let vaildEmail = (newUserForm.email) ? (validateEmail(newUserForm.email) ? true : false) : false;
    next(ModalActions.DocumentActions.setContextItemProperty({id: 'newExternalUser', name: 'errors', value: {...((getGenericModal('newExternalUser')(getState()) as Modal).contextItem as ExternalUserForm).errors, email: (!newUserForm.email) ? 'This field is mandatory' : ((vaildEmail) ? undefined : 'Invalid email format')}}));
    next(ModalActions.DocumentActions.setContextItemProperty({id: 'newExternalUser', name: 'errors', value: {...((getGenericModal('newExternalUser')(getState()) as Modal).contextItem as ExternalUserForm).errors, company: (!newUserForm.company) ? 'This field is mandatory' : undefined}}));
    next(ModalActions.DocumentActions.setContextItemProperty({id: 'newExternalUser', name: 'errors', value: {...((getGenericModal('newExternalUser')(getState()) as Modal).contextItem as ExternalUserForm).errors, country: (!newUserForm.country) ? 'This field is mandatory' : undefined}}));
    next(ModalActions.DocumentActions.setContextItemProperty({id: 'newExternalUser', name: 'errors', value: {...((getGenericModal('newExternalUser')(getState()) as Modal).contextItem as ExternalUserForm).errors, role: (!newUserForm.role) ? 'This field is mandatory' : undefined}}));
}